export default "<span class=\"icon-22 \" [ngClass]=\"[icon, color]\" [class.icon-absolute]=\"isInputIcon\"></span>";